<template>
    <div class="card">
        <div class="card-body overflow-auto chat chat-container" ref="chatContainer">
            <div ref="chatContent">
                <div class="mb-2" v-for="message in messages" :key="message.id">
                    <div>
                        <b>{{ message.user.first_name }} {{ message.user.last_name }}</b>
                        <span :id="'message-'+message.id">
                            {{ message.created_at | relative }}
                        </span>
                        <b-tooltip :target="'message-'+message.id" triggers="hover">
                            {{ message.created_at | exact }}
                        </b-tooltip>
                    </div>
                    {{ message.content }}
                </div>
            </div>
        </div>
        <div class="card-footer">
            <form v-on:submit="submit">
                <div class="input-group">
                    <input v-model="newMessage" type="text" placeholder="Messaggio..." :disabled="inputDisabled" class="form-control">
                    <span class="input-group-append">
                      <input :disabled="inputDisabled" type="submit" class="btn btn-primary" value="Invia" />
                    </span>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    const axios = require('axios');
    const moment = require('moment');

    export default {
        name: "Chat",
        data() {
            return {
                messages: [],
                newMessage: "",
                inputDisabled: false
            }
        },
        filters: {
            relative: function (date) {
                moment.locale('it');
                return moment(date).fromNow();
            },
            exact: function (date) {
                moment.locale('it');
                return moment(date).format("LLL");
            }
        },
        props: {
            eventId: String
        },
        methods: {
            submit: function (event) {
                event.preventDefault();

                if (this.newMessage === "") return;

                this.inputDisabled = true;
                axios.post(`/eventi/${this.$props.eventId}/send_message`, { message: this.newMessage})
                    .then(function () {
                        this.newMessage = "";
                        this.inputDisabled = false;
                    }.bind(this));
            }
        },
        mounted() {
            axios.get(`/eventi/${this.$props.eventId}/get_old_messages`).then(function (response) {
                this.messages = response.data;
                Echo.channel(`event.${this.$props.eventId}`)
                    .listen('ChatMessageReceived', (e) => {
                        this.messages.push(e.chatMessage);
                    });
            }.bind(this));
        },
        updated() {
            this.$refs.chatContainer.scrollTop = this.$refs.chatContent.clientHeight;
        }
    }
</script>

<style scoped>
  .chat-container {
    max-height: 21vw;
  }
</style>
